import { FormField } from '@acast/decibel';
import T from 'prop-types';
import React from 'react';

const Field = ({
  name,
  label,
  children,
  subtitle,
  input,
  meta,
  isRequired,
  help,
  disabled,
  renderToggleDisabled,
}) => {
  const hasError = !!(meta.touched && meta.error);

  const getHelperText = () => {
    if (hasError) {
      return meta.error;
    }

    if (subtitle && typeof subtitle === 'function') {
      return subtitle(input.value);
    }

    return subtitle;
  };

  return (
    <FormField
      id={name}
      required={isRequired}
      label={label}
      action={renderToggleDisabled && renderToggleDisabled(disabled)}
      invalid={hasError}
      helperText={getHelperText()}
      tooltipText={help}
      disabled={disabled}
    >
      {children}
    </FormField>
  );
};

Field.propTypes = {
  name: T.string,
  label: T.string,
  children: T.node,
  subtitle: T.oneOfType([T.string, T.func, T.node]),
  input: T.object,
  meta: T.object,
  isRequired: T.bool,
  disabled: T.bool,
  help: T.node,
  renderToggleDisabled: T.func,
};

Field.defaultProps = {
  input: {},
  meta: {},
};

export default Field;
